module.exports = __webpack_public_path__ + "static/media/right.780e2162.svg";